// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"440":"06694850","516":"68523de1"}[chunkId] + ".js";
};